import md5 from 'md5';
/** 获取用户信息
 * eg:
 *  var guid      = getUserInfo().getGuid();         // 获取用户唯一guid
 *  var nickname  = getUserInfo().getNickname();     // 获取用户昵称
 *  var userimage = getUserInfo().getUserImage();    // 获取用户昵称
 *  var getTimer  = getUserInfo().getTimer();        // cx红包后删
 *  var getNewDay = getUserInfo().getNewDay();       // cx红包后删
 */
export const getUserInfo = () => {
    return grounds.getUserInfo();
};
/** 获取设备信息
 * eg:
 *  var gv              = getDeviceInfo().getGv();             // 获取APP版本号
 *  var os              = getDeviceInfo().getOs();             // 获取手机系统
 *  var deviceid        = getDeviceInfo().getDeviceId();       // 获取设备唯一标识
 *  var proid           = getDeviceInfo().getProid();          // 获取客户端产品标识
 *  var publishid       = getDeviceInfo().getPublishid();      // 获取客户端发布渠道id
 *  var getPushInfo     = getDeviceInfo().getPushInfo();       // cx红包后删
 *  var getManufacturer = getDeviceInfo().getManufacturer();   // cx红包后删
 */
export const getDeviceInfo = () => {
    return grounds.getDeviceInfo();
};
/** 获取日夜间模式,
 * day为日间, night为夜间
 */
export const getShowMode = () => {
    return grounds.getShowMode();
};
/**
 * 判断用户是否登录
 */
export const userIsLogin = () => {
    return grounds.userIsLogin();
};
/**
 * 获取app名
 */
export const getAppName = () => {
    return grounds.getDeviceInfo().getProid();
};
export const getTokenAndTimestamp = (liveId) => {
    // "{时间前3位}{直播间id}_{用户guid}{时间后6位}"
    let guid = grounds.getUserInfo().getGuid();
    let timeStamp = Date.now() + '';
    let t3 = timeStamp.substr(0, 3) + '';
    let t6 = timeStamp.substr(4, 6) + '';
    let md5_string = t3 + liveId + '_' + guid + t6;
    let token = md5(md5(md5(md5_string)));
    let time = t3 + '' + t6;
    return { token, time };
};
/**
 * 判断客户端是否大于某个版本
 * @param version {string}
 */
export const isGVNewer = (version) => {
    const getGVNum = (v) => {
        let vArr = v.split('.').map((num) => parseInt(num));
        return vArr[0] * 10000 + vArr[1] * 100 + vArr[2];
    };
    const cvNum = getGVNum(grounds.getDeviceInfo().getGv());
    const versionNum = getGVNum(version);
    return cvNum > versionNum;
};
